import type { AiStepStatus } from '../ui/ai-motion'
import type { ExtractedRow, ImportEvent, ImportStage, ImportTool, ReviewedRow } from './types'

// What the live read has shown so far, folded from the streamed import events.

export type LiveImportState = {
  stage: ImportStage
  fileName: string
  rows: ExtractedRow[]
  matched: Record<string, ReviewedRow>
  steps: Record<string, Partial<Record<ImportTool, { status: AiStepStatus; summary: string }>>>
  warnings: string[]
}

export const emptyLiveImport = (fileName: string): LiveImportState => ({
  stage: 'opening',
  fileName,
  rows: [],
  matched: {},
  steps: {},
  warnings: [],
})

export function applyImportEvent(state: LiveImportState, event: ImportEvent): LiveImportState {
  switch (event.type) {
    case 'stage':
      return {
        ...state,
        stage: event.stage,
        fileName: event.file_name ?? state.fileName,
      }
    case 'row':
      return { ...state, rows: [...state.rows.filter((row) => row.row_id !== event.row.row_id), event.row] }
    case 'tool':
      return {
        ...state,
        steps: {
          ...state.steps,
          [event.row_id]: { ...state.steps[event.row_id], [event.tool]: { status: event.status, summary: event.summary } },
        },
      }
    case 'matched':
      return { ...state, matched: { ...state.matched, [event.row.row_id]: event.row } }
    case 'warning':
      return { ...state, warnings: [...state.warnings, event.text] }
    default:
      return state
  }
}

export function liveProgress(state: LiveImportState) {
  const found = state.rows.length
  const done = found ? Object.keys(state.matched).length / found : 0
  if (state.stage === 'opening') return 0.04
  if (state.stage === 'reading') return 0.1 + 0.5 * (found / (found + 4)) * (0.5 + 0.5 * done)
  if (state.stage === 'matching') return 0.6 + 0.3 * done
  return 0.97
}

